export function readDeepLinkedWord() {
  try {
    const mot = new URLSearchParams(window.location.search).get("mot");
    return mot && mot.trim() ? mot.trim() : null;
  } catch {
    return null;
  }
}

export function openWordInNewTab(mot) {
  if (!mot) return;

  const url = new URL(window.location.href);
  url.search = "";
  url.hash = "";
  url.searchParams.set("mot", mot);
  window.open(url.toString(), "_blank", "noopener,noreferrer");
}
